/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Stable machine-readable Dependency API error.
 */
export type RoadmapDependencyErrorDetail = {
    code: RoadmapDependencyErrorDetail.code;
    message: string;
};

export namespace RoadmapDependencyErrorDetail {

    export enum code {
        ROADMAP_DEPENDENCIES_UNAVAILABLE = 'roadmap_dependencies_unavailable',
        ROADMAP_DEPENDENCIES_STALE_TOKEN = 'roadmap_dependencies_stale_token',
        ROADMAP_DEPENDENCIES_UNKNOWN_TIMEFRAME = 'roadmap_dependencies_unknown_timeframe',
        ROADMAP_DEPENDENCIES_UNKNOWN_SCOPE = 'roadmap_dependencies_unknown_scope',
        ROADMAP_DEPENDENCIES_UNKNOWN_QUARTER = 'roadmap_dependencies_unknown_quarter',
        ROADMAP_DEPENDENCIES_UNKNOWN_VIEW = 'roadmap_dependencies_unknown_view',
        ROADMAP_DEPENDENCIES_UNKNOWN_STATUS = 'roadmap_dependencies_unknown_status',
        ROADMAP_DEPENDENCIES_UNKNOWN_PRIORITY = 'roadmap_dependencies_unknown_priority',
        ROADMAP_DEPENDENCIES_UNKNOWN_GROUP = 'roadmap_dependencies_unknown_group',
        ROADMAP_DEPENDENCIES_INVALID_CURSOR = 'roadmap_dependencies_invalid_cursor',
        ROADMAP_DEPENDENCIES_IDENTITY_UNAVAILABLE = 'roadmap_dependencies_identity_unavailable',
        ROADMAP_DEPENDENCIES_INVALID_FILTER = 'roadmap_dependencies_invalid_filter',
    }


}

